import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { deletePreset } from '@api/crowdCellPresets';

import { ESnackbarTypes } from '@enums/common';

import { CROWD_CELL_DELETE_PRESETS, CROWD_CELL_PRESETS } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export function useDeleteConfigPreset(onSuccess?: () => void, onError?: () => void): {
	deleteConfigPreset: (presetId: string) => void;
	isPresetDeleting?: boolean;
} {
	const dispatch = useAppDispatch();
	const queryClient = useQueryClient();

	const {
		mutate: deleteConfigPreset,
		isLoading,
	} = useMutation<string>({
		mutationFn: deletePreset,
		onError: () => {
			if (onError) {
				onError();
			}

			dispatch(setSnackbar({
				message: responseMessages.error,
				type: ESnackbarTypes.error,
			}));
		},
		onSuccess: () => {
			if (onSuccess) {
				onSuccess();
			}

			return [
				queryClient.invalidateQueries([CROWD_CELL_PRESETS]),
			];
		},
		mutationKey: [CROWD_CELL_DELETE_PRESETS],
	});

	return {
		deleteConfigPreset,
		isPresetDeleting: isLoading,
	};
}
